// components/HiringPipeline/config/hiringConfig.ts

export interface CandidateStage {
  stage: string;
  count: number | null;
  color: string;
}

export interface JobPipeline {
  title: string;
  totalApplications: number;
  stages: CandidateStage[];
}

export const STAGE_CONFIG = [
  { key: "screening", label: "Screening", color: "bg-purple-500" },
  { key: "L1", label: "L1 Round", color: "bg-purple-500" },
  { key: "L2", label: "L2 Round", color: "bg-purple-500" },
  { key: "L3", label: "L3 Round", color: "bg-purple-500" },
  { key: "L4", label: "L4 Round", color: "bg-purple-500" },
  { key: "managerRound", label: "Manager Round", color: "bg-purple-500" },
];
